import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.12 25a2 2 0 0 1-1.722-3.008c.955-1.642 1.576-4.104 1.624-7.555L6.025 14v-.998A9.987 9.987 0 0 1 16.076 3c5.388.04 9.75 4.431 9.896 9.833l.004.28V14c0 3.682.632 6.282 1.624 7.99a2 2 0 0 1-1.558 3.003l-.165.007H21a5 5 0 0 1-9.995.217L11 25zM13 25a3 3 0 0 0 5.995.177L19 25zm2.759-19.996L16.06 5l.247.006c4.259.165 7.668 3.751 7.668 8.107V14l.003.477c.052 3.62.703 6.336 1.756 8.275l.14.248H6.124l.14-.248c1.1-2.024 1.76-4.893 1.76-8.752v-1l.006-.303a7.99 7.99 0 0 1 7.728-7.693"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconNotifications = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconNotifications);
export default Memo;
